import Box from "@mui/material/Box";
import {
  TASK_ALERT_ERROR_MESSAGE_BG,
  TASK_ALERT_ERROR_MESSAGE_BORDER,
} from "../../utils/colors";

/**
 * Styled container for error message content inside task alert cards.
 */
const TaskAlertErrorMessage = ({ children, sx = {} }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 1,
      alignItems: "flex-start",
      width: "100%",
      p: 1,
      borderRadius: 1.5,
      border: "1px solid",
      borderColor: TASK_ALERT_ERROR_MESSAGE_BORDER,
      bgcolor: TASK_ALERT_ERROR_MESSAGE_BG,
      overflow: "hidden",
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default TaskAlertErrorMessage;
